import PinList from "@/components/PinList";
import { getAds, getRecommendPins } from "@/services";
import { getExpsValue } from "@/tracker/abTest";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import useRequest from "@/utils/useReq";
import { useSetState } from "ahooks";
import { useCallback, useEffect, useMemo, useState } from "react";

// 为你推荐
export default function PinRecommendPinList({ pinId, isModal, fileId }) {
  const [query, setQuery] = useSetState({
    page: 1,
    pinId: null,
  });
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [ads, setAds] = useState([]);
  const [scrollableTarget, setScrollableTarget] = useState(null);
  const [masonryKey, setMasonryKey] = useState(null);

  // 解决瀑布流容器大小判断，因为弹窗过程需要时间，延迟计算
  useEffect(() => {
    const timeout = setTimeout(() => {
      setMasonryKey(pinId);
    }, 400);

    return () => {
      clearTimeout(timeout);
    };
  }, [pinId]);

  useRequest(
    async () => {
      const { page, pinId } = query;

      if (!pinId) {
        return;
      }

      const result = await getRecommendPins({
        pin_id: pinId,
        per_page: 20,
        page,
      });

      const pins = result?.pins || [];

      if (pins.length <= 0) {
        setHasMore(false);
      }

      setDataSource(dataSource.concat(pins));
    },
    {
      refreshDeps: [query],
    }
  );

  useRequest(async () => {
    const result = await getAds({
      positions: [53, 57],
      file_id: fileId,
    });

    // ab实验：0: 只展示人工投放内容，1: 人工投放内容+智能生成投放内容
    const abTestStrategy = await getExpsValue("abtest_ad_strategy", "1");

    setAds(
      result?.reduce((result, item) => {
        if (item) {
          if (
            abTestStrategy == 0 &&
            item.material?.link?.includes("from=auto")
          ) {
            result.push(null);
            return result;
          }
          result.push({
            ...item,
            pin_id: `recommend-${item.material.id}`,
            type: "recommend",
          });
        } else {
          result.push(null);
        }
        return result;
      }, []) || []
    );
  });

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      setQuery({
        page: query.page + 1,
      });

      pvTracker(getPageData());
    }
  }, [dataSource, query, setQuery]);

  useEffect(() => {
    if (pinId) {
      setHasMore(true);
      setDataSource([]);
      setQuery({
        page: 1,
        pinId,
      });
    }
  }, [pinId, setQuery]);

  useEffect(() => {
    if (isModal) {
      setScrollableTarget(document.querySelector(".pinDetailModal"));
    }
  }, [isModal]);

  const list = useMemo(() => {
    if (dataSource.length <= 0 || ads.length <= 0) {
      return dataSource;
    }
    const list = [...ads.slice(0, 1).filter((i) => i), ...dataSource];

    return [
      ...list.slice(0, 3),
      ...ads.slice(1, 2).filter((i) => i),
      ...list.slice(3),
    ];
  }, [dataSource, ads]);

  if (isModal && !scrollableTarget) {
    return null;
  }

  return (
    <PinList
      disableModal={!isModal}
      disableQueue={true}
      disableFile={true}
      dataSource={list}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      scrollableTarget={scrollableTarget}
      masonryKey={masonryKey}
      isModal={isModal}
    />
  );
}
